/**
 * Task 30 (cut-over): pulled out of `components/roles/RolesPage.tsx` into this leaf module so
 * `RolesPage.tsx` and `TemplatePickerDialog.tsx` can both import it without a circular dependency
 * (`RolesPage` previously exported it while also importing `TemplatePickerDialog`, which imported
 * it back).
 *
 * RULING R30-1: stays `false` for this cut-over — do NOT flip it here. Before flipping, work
 * through the "Pre-`ROLE_FREEFORM_ENABLED` checklist" section of
 * `docs/runbooks/dynamic-roles-rollout.md`.
 */
export const ROLE_FREEFORM_ENABLED = false;
